//TODO Edit course tool
//Add option
const courseModal = document.querySelector("#addCourse");

window.createCourseOption = (form, index, courseAddOptionBtn) => {
    const elem = document.createElement('div');
    const stamp = Date.now();
    elem.classList.add('row', 'mb-2', 'position-relative', 'pe-4', 'option-item');
    elem.innerHTML = `
        <div class="col-12 col-md-6">
            <div class="form-floating mb-3">
                <input name="options[${index}][id]" type="hidden" value="${index}">
                <input name="options[${index}][des]" class="form-control" id="option-des-${stamp}" placeholder="Option name (package name)" value="" required>
                <label for="option-des-${stamp}">Option name (package name)</label>
            </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="form-floating mb-3">
                <input name="options[${index}][qty]" type="number" class="form-control" id="option-qty-${stamp}" placeholder="Quantity (sessions)" value="" required>
                <label for="option-qty-${stamp}">Sessions</label>
            </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="form-floating mb-3">
                <input name="options[${index}][price]" type="number" class="form-control" id="option-price-${stamp}" placeholder="Price ({$course.currency})" value="" required>
                <label for="option-price-${stamp}">Price</label>
            </div>
        </div>
    `;
    if (index > 0) elem.innerHTML += `<button type="button" class="btn-close position-absolute end-0" onclick="this.parentElement.remove()" style="top:1.125rem"></button>`;
    form.appendChild(elem);
    courseAddOptionBtn.dataset.index = Number(index) + 1;
}

const addCourseToList = (data) => {
    const course = JSON.parse(data);
    const courseList = document.querySelector("#courseList tbody");
    const row = document.createElement('tr');
    row.innerHTML = `
        <td><a href="courses/course.html?cid=${course[0].id}&act=view">${course[0].name}</a></td>
        <td class="text-end">
            <div class="d-inline-flex align-items-center gap-2">
                <a href="#" class="btn btn-outline-brand-secondary btn-sm p-2" title="Attendance Today" data-bs-toggle="modal" data-bs-target="#attendanceModal" data-cid=${course.id}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px"><path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"/></svg>
                    <span class="d-none d-lg-inline">Attendance</span>
                </a>
                <a href="courses/course.html?cid=${course[0].id}&act=view" class="btn btn-brand-secondary btn-sm p-2" title="View">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 576 512"><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path></svg>                    
                    <span class="d-none d-lg-inline">View</span>
                </a>
                <a href="courses/course.html?cid=${course[0].id}&act=edit" class="btn btn-success btn-sm p-2" title="Edit Course" disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20px" height="20px"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>
                    <span class="d-none d-lg-inline">Edit</span>
                </a>
                <a href="#" class="btn btn-danger btn-sm p-2 disabled" title="Remove Course" disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                    <span class="d-none d-lg-inline">Remove</span>
                </a>
            </div>
        </td>
    `;
    courseList.appendChild(row);
}

// Updated Event Listener for Adding a Course
if (courseModal) {
    const courseForm = document.querySelector("#addCourse form");
    const courseAddOptionBtn = courseModal.querySelector(".add-opt-btn");

    courseModal.addEventListener('show.bs.modal', () => {
        courseAddOptionBtn.click();
    });

    courseAddOptionBtn.addEventListener('click', (e) => {
        let index = e.currentTarget.dataset.index;
        createCourseOption(courseForm, index, courseAddOptionBtn);
    });

    const addCourseBtn = document.getElementById('addCourseBtn');
    addCourseBtn.addEventListener('click', (e) => {
        if (!courseForm.checkValidity()) {
            courseForm.classList.add('was-validated');
        } else {
            const targetElement = courseModal.querySelector('.modal-content');
            const preloader = addPreloader(targetElement); // Use the global addPreloader function

            const formData = new FormData(courseForm);
            const values = Object.fromEntries(formData.entries());
            postData('/actions/dash/courses.php', values).then(data => {
                console.log(data);
                if (data.success) {
                    const myModal = bootstrap.Modal.getOrCreateInstance(courseModal);
                    myModal.hide();
                    courseForm.classList.remove('was-validated');
                    courseForm.reset();
                    courseAddOptionBtn.dataset.index = 0;
                    const options = courseForm.querySelectorAll('.option-item');
                    options.forEach((option) => {
                        option.remove();
                    });
                    addCourseToList(data['success']);
                    showToast('Course has been added successfully.');
                }
                removePreloader(preloader); // Use the global removePreloader function
            }).catch(error => {
                console.error(error);
                removePreloader(preloader); // Ensure preloader is removed on error
                showToast('Course has been added successfully.', 'danger');
            });
        }
    });
}

// EDIT COURSE TOOLS

// Save course button
const courseSaveBtn = document.querySelector("#courseSaveBtn");
if (courseSaveBtn) {
    courseSaveBtn.addEventListener('click', (e) => {
        const courseForm = document.querySelector("#course-editor");
        if (!courseForm.checkValidity()) {
            courseForm.classList.add('was-validated');
        } else {
            const preloader = addPreloader(courseForm); // Use the global addPreloader function
            const formData = new FormData(courseForm);
            const values = Object.fromEntries(formData.entries());
            postData('/actions/dash/courses.php', values).then(data => {
                console.log(data);
                if (data.success) {
                    
                    
                    courseForm.classList.remove('was-validated');
                    showToast(data.success);
                }
                removePreloader(preloader); // Use the global removePreloader function
            }).catch(error => {
                console.error(error);
                removePreloader(preloader); // Ensure preloader is removed on error
                showToast('Error updating course.', 'danger');
            });
        }
    });
}